import React from "react";
import "./Verein.css";

export default function Verein() {
  return (
    <main className="verein-container">
      <h1>Über den Verein</h1>

      <section className="verein-section">
        <p>
          Die{" "}
          <strong>Schwimm- und Tauchgemeinschaft Diver Duck Berlin e.V.</strong>{" "}
          wurde am <strong>01.01.2009</strong> gegründet. Sie entstand aus der
          Fusion der Vereine „Schwimm- und Tauchgemeinschaft Berlin e.V.“ und
          „Tauchclub Diver Duck Berlin e.V.“. Unser Vereinskurzname ist{" "}
          <strong>STG Diver Duck</strong>.
        </p>
        <p>
          Der Verein hat derzeit etwa <strong>30 Mitglieder</strong>, darunter
          engagierte <strong>Tauchlehrer:innen</strong> und{" "}
          <strong>Übungsleiter:innen</strong>. Wir sind in{" "}
          <strong>Kreuzberg</strong> zu Hause – ursprünglich im Spreewaldbad,
          das allerdings bis voraussichtlich 2026 saniert wird. Aktuell
          trainieren wir im <em>Prinzenbad</em> und im{" "}
          <em>Kombibad Seestraße</em>.
        </p>
        <p>
          ➤{" "}
          <a href="/pdfs/Satzung.pdf" target="_blank" rel="noopener noreferrer">
            Vereinssatzung (PDF)
          </a>
        </p>
         <p>
          ➤{" "}
          <a href="/pdfs/Beitragsordnung.pdf" target="_blank" rel="noopener noreferrer">
            Beitragsordnung (PDF)
          </a>
        </p>
      </section>

      {/*
      <section className="timeline">
        <h2>Vereinsgeschichte</h2>
        <ul>
          <li>
            <span className="jahr">2009</span> Gründung durch Fusion zweier
            Vereine
          </li>
          <li>
            <span className="jahr">2023</span> Spreewaldbad wird geschlossen
          </li>
          <li>
            <span className="jahr">2026</span> Geplante Wiedereröffnung des
            Spreewaldbads
          </li>
        </ul>
      </section>
      */}
      <section className="verein-section">
        <h2>Vorstand</h2>
        <div className="board-grid">
          <div>
            <strong>1. Vorsitzender:</strong>
            <br />
            Hans-Joachim Weidner
          </div>
          <div>
            <strong>2. Vorsitzende:</strong>
            <br />
            Marita Storim
          </div>
          <div>
            <strong>Geschäftsführerin:</strong>
            <br />
            Jacqueline Lessow
          </div>
          <div>
            <strong>Kassenwartin:</strong>
            <br />
            Vanessa Lessow
          </div>
        </div>

        <h3>Erweiterter Vorstand</h3>
        <div className="board-grid small">
          <div>
            <strong>Ausbildungsleiter:</strong>
            <br />
            Martin Lessow
          </div>
          <div>
            <strong>Administrator & Datenschutz:</strong>
            <br />
            Lars Temme
          </div>
        </div>
      </section>

      <section className="verein-section">
        <h2>Unsere Verbände</h2>
        <div class="table-wrap">
          <table className="verband-table">
            <thead>
              <tr>
                <th>Verband</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Landessportbund Berlin</td>
                <td>
                  <a
                    href="https://www.lsb-berlin.net"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    lsb-berlin.net
                  </a>
                </td>
              </tr>
              <tr>
                <td>Verband Deutscher Sporttaucher (VDST)</td>
                <td>
                  <a
                    href="https://www.vdst.de"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    vdst.de
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}
